(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["li-store-header"]) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.li-store-header details[open]').forEach(item=>{if(!item.contains(event.target))item.removeAttribute('open')})});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const open=Array.from(document.querySelectorAll('.li-store-header details[open]')).reverse();if(open.length){open[0].removeAttribute('open');open[0].querySelector('summary').focus()}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
